import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import {Post} from "../models/post.model";
import {LocationModel} from "../models/location.model";

@Injectable()
export class ObservablepostService {
  key:string;

  publications?:Post[] = [];
  location:LocationModel;
  publicationTemp?:Post;
  no_access_field:boolean = false;
  

  private messagePosts = new BehaviorSubject<Post[]>(this.publications);
  private messageLocation = new BehaviorSubject<LocationModel>(this.location);
  private messageNoaccessfield = new BehaviorSubject<boolean>(this.no_access_field);

  currentPosts = this.messagePosts.asObservable();
  currentLocation = this.messageLocation.asObservable();
  currentAccess = this.messageNoaccessfield.asObservable();

  constructor() {

  }

  changeVal(publications:Post[]){
    // console.log("ObservablepostService changeVal");
    this.messagePosts.next(publications);
  }

  changeValLocation(location:LocationModel){
    // console.log("ObservablepostService changeVallocation");
    this.messageLocation.next(location);
  }
  changeValNoAccessField(no_access:boolean){
    // console.log("ObservablepostService changeVal");
    this.messageNoaccessfield.next(no_access);
  }


}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/services/observablepost.service.ts